import React, { PureComponent, Fragment } from 'react'

import PremiumActivitiesIntro from './premium_activities_intro/PremiumActivitiesIntro'
import PremiumActivitiesAddLesson from './premium_activities_add_lesson/PremiumActivitiesAddLesson'

class PremiumActivitiesNotification extends PureComponent {

	constructor() {
		super()
		this.state = {
			shouldShowIntro: true,
		}
	}

	toggleView = () => {
		this.setState({
			shouldShowIntro: false,
		})
	}

	render() {

		return (
			<Fragment>
				{ this.state.shouldShowIntro && <PremiumActivitiesIntro introCompleted={this.toggleView}/> }
				{ !this.state.shouldShowIntro && <PremiumActivitiesAddLesson /> }
			</Fragment>
		)
	}
}


export default PremiumActivitiesNotification
